const Icon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.41113C4.1375 1.41113 1 4.54863 1 8.41113C1 12.2736 4.1375 15.4111 8 15.4111C11.8625 15.4111 15 12.2736 15 8.41113C15 4.54863 11.8625 1.41113 8 1.41113ZM8 14.4111C4.6875 14.4111 2 11.7236 2 8.41113C2 5.09863 4.6875 2.41113 8 2.41113C11.3125 2.41113 14 5.09863 14 8.41113C14 11.7236 11.3125 14.4111 8 14.4111ZM8.5 8.26113L11.4875 9.98613L10.9875 10.8486L7.6375 8.91113H7.5V4.41113H8.5V8.26113Z"
      fill="#8A919F"
    />
  </svg>
);

export default Icon;
